import React from 'react';
import { FormContext, useForm } from 'react-hook-form';
import {
  buildSendoutInterviewPayload,
  SendoutInterviewForm
} from 'features/sendouts/components/forms/SendoutInterviewForm';
import strings from 'strings';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { getInterviewTimeValidationError } from '../CreateSendoutDrawer/CreateSendoutDrawer.utils';
import { FORM_FIELDS_MAP } from '../CreateSendoutDrawer/SendoutForm/SendoutForm.constants';

export const CreateSendoutInterviewDrawer = ({
  isSubmitting = false,
  onClose = () => {},
  onSaved = () => {}
}) => {
  const form = useForm();
  const { clearError, handleSubmit, setError } = form;

  const handleSave = async formData => {
    const interviewTimeValidationError = getInterviewTimeValidationError(formData);

    if (interviewTimeValidationError) {
      setError(
        interviewTimeValidationError.fieldKey,
        'validate',
        interviewTimeValidationError.message
      );
      return;
    }

    clearError(FORM_FIELDS_MAP.InterviewFromHour.key);
    clearError(FORM_FIELDS_MAP.InterviewToHour.key);

    const payload = buildSendoutInterviewPayload(formData);

    await onSaved({ payload });
  };

  const buttonDefinitions = [
    {
      props: {
        text: strings.shared.ui.cancel,
        variant: 'outlined',
        onClick: onClose,
        disabled: isSubmitting
      },
      GridItemProps: { md: 3 }
    },
    {
      props: {
        text: strings.shared.ui.save,
        variant: 'contained',
        onClick: handleSubmit(handleSave),
        disabled: isSubmitting,
        isSaving: isSubmitting
      },
      GridItemProps: { md: 3 },
      mode: 'save'
    }
  ];

  return (
    <FPDrawer
      FPDrawerProps={{ open: true }}
      CardHeaderProps={{ title: strings.sendoutsV2.drawers.createSendoutInterview.title }}
      onClose={onClose}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <FormContext {...form}>
        <SendoutInterviewForm />
      </FormContext>
    </FPDrawer>
  );
};
